import React, { Component } from 'react';
import { RouteComponentProps } from 'react-router'
import * as Yup from 'yup';
import { Formik, FormikHelpers as FormikActions, FormikProps, Form, Field, FieldProps } from 'formik';
import { API_LOG_IN_REQ, API_LOG_IN as LoginApi } from '../api'
import { Link } from 'react-router-dom'
import { Button } from '../components/elements';
import { t, getLang } from '../i18n';

const REMEMBER_KEY = 'featmap_remember'

const makeSchema = () => Yup.object().shape({
    email: Yup.string()
        .email(getLang() === 'zh' ? '邮箱格式不正确。' : 'Email invalid.')
        .required(getLang() === 'zh' ? '请填写邮箱。' : 'Email required.'),
    password: Yup.string()
        .min(6, getLang() === 'zh' ? '密码至少 6 位。' : 'Password minimum 6 characters.')
        .max(200, getLang() === 'zh' ? '密码最多 200 位。' : 'Password maximum 200 characters.')
        .required(getLang() === 'zh' ? '请填写密码。' : 'Password required.'),
});

interface PropsFromState { }
interface RouterProps extends RouteComponentProps<{}> { }
interface PropsFromDispatch { }
interface SelfProps { }
type Props = RouterProps & PropsFromState & PropsFromDispatch & SelfProps

interface State {
    lang: string
    remember: boolean
    savedEmail: string
    savedPassword: string
}

class LogIn extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        // 读取已保存的凭据
        let savedEmail = ''
        let savedPassword = ''
        let remember = false
        try {
            const raw = localStorage.getItem(REMEMBER_KEY)
            if (raw) {
                const parsed = JSON.parse(raw)
                savedEmail = parsed.email || ''
                savedPassword = parsed.password || ''
                remember = true
            }
        } catch (_) { }

        this.state = { lang: getLang(), remember, savedEmail, savedPassword }
    }

    componentDidMount() {
        window.addEventListener('featmap_lang_change', this.onLangChange)
    }
    componentWillUnmount() {
        window.removeEventListener('featmap_lang_change', this.onLangChange)
    }
    onLangChange = () => this.setState({ lang: getLang() })

    render() {
        const { history } = this.props
        const { remember, savedEmail, savedPassword } = this.state

        return (
            <div className="flex p-2 w-full justify-center items-center flex-col">
                <div className="flex p-3 max-w-xl w-full items-center flex-col">
                    <div className="flex p-2 flex-col items-baseline">
                        <div className="p-1"><h1 className="text-3xl font-medium">{t('login_title')}</h1></div>
                    </div>
                    <div className="flex p-2 flex-col items-baseline">
                        <div className="p-1">{t('login_hint')}</div>
                    </div>

                    <div>
                        <Formik
                            initialValues={{ email: savedEmail, password: savedPassword }}
                            initialStatus=""
                            enableReinitialize={false}
                            validationSchema={makeSchema()}
                            onSubmit={(values: API_LOG_IN_REQ, actions: FormikActions<API_LOG_IN_REQ>) => {
                                actions.setStatus("")
                                LoginApi(values).then(response => {
                                    if (response.ok) {
                                        // 登录成功：按勾选状态写入或清除凭据
                                        if (this.state.remember) {
                                            localStorage.setItem(REMEMBER_KEY, JSON.stringify({
                                                email: values.email,
                                                password: values.password,
                                            }))
                                        } else {
                                            localStorage.removeItem(REMEMBER_KEY)
                                        }
                                        response.json().then(() => history.push("/"))
                                    } else {
                                        actions.setStatus(t('login_error'))
                                    }
                                })
                                actions.setSubmitting(false)
                            }}>
                            {(formikBag: FormikProps<API_LOG_IN_REQ>) => (
                                <Form>
                                    <div className="p-1 text-red-500 text-xs font-bold">{formikBag.status}</div>
                                    <Field name="email">
                                        {({ form }: FieldProps<API_LOG_IN_REQ>) => (
                                            <div className="flex flex-row items-baseline">
                                                <div className="flex flex-col w-full">
                                                    <div><input type="text" placeholder={getLang() === 'zh' ? '邮箱' : 'Email'} value={form.values.email} onChange={form.handleChange} id="email" className="rounded p-2 border w-64 text-lg" /></div>
                                                    <div className="p-1 text-red-500 text-xs font-bold">{form.touched.email && form.errors.email}</div>
                                                </div>
                                            </div>
                                        )}
                                    </Field>
                                    <Field name="password">
                                        {({ form }: FieldProps<API_LOG_IN_REQ>) => (
                                            <div className="flex flex-row items-baseline">
                                                <div className="flex flex-col w-full">
                                                    <div><input type="password" value={form.values.password} onChange={form.handleChange} placeholder={getLang() === 'zh' ? '密码' : 'Password'} id="password" className="rounded p-2 border w-64 text-lg" /></div>
                                                    <div className="p-1 text-red-500 text-xs font-bold">{form.touched.password && form.errors.password}</div>
                                                </div>
                                            </div>
                                        )}
                                    </Field>

                                    {/* 记住我 */}
                                    <div className="flex flex-row items-center mt-1 mb-2">
                                        <input
                                            type="checkbox"
                                            id="remember"
                                            checked={this.state.remember}
                                            onChange={e => this.setState({ remember: e.target.checked })}
                                            className="mr-2 cursor-pointer"
                                        />
                                        <label htmlFor="remember" className="text-sm text-gray-600 cursor-pointer select-none">
                                            {t('login_remember')}
                                        </label>
                                    </div>

                                    <div className="flex flex-row items-baseline justify-center">
                                        <div className="justify-center">
                                            <Button primary submit title={t('login_btn')} />
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>

                    <div className="flex p-2 flex-col">
                        <div className="p-1 text-center">{t('login_no_account')} <Link className="link" to="/account/signup">{t('login_create')}</Link></div>
                        <div className="p-1 text-center">{t('login_forgot')} <Link className="link" to="/account/reset">{t('login_reset')}</Link></div>
                    </div>
                </div>
            </div>
        );
    }
}

export default LogIn
